module.exports = {"id":"dp4_4l3q1","text":"Environmental Impacts of Digital Technologies","instructions":"Digital technologies can have environmental impacts across their full lifecycle.","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"4.4","questionType":"PickOne","random":false,"options":[{"id":"dp4_4l3q1-a1","text":"True","score":3.7},{"id":"dp4_4l3q1-a2","text":"Not sure","score":1.3},{"id":"dp4_4l3q1-a3","text":"False","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat4.4/l3q1.json
// module id = 1271
// module chunks = 41